import Vue from 'vue'

import Router from 'vue-router'
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/page/login')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import(/* webpackChunkName: "index" */ '@/page/index'),
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '@/components/home'),
        meta: {
          title: '主页统计'
        }
      },
      {
        path: 'statistics',
        name: 'statistics',
        component: () => import(/* webpackChunkName: "statistics" */ '@/components/statistics'),
        meta: {
          title: '统计清单'
        }
      },
      {
        path: 'check',
        name: 'check',
        component: () => import(/* webpackChunkName: "check" */ '@/components/check'),
        meta: {
          title: '检查记录'
        }
      },
      {
        path: 'ship',
        name: 'ship',
        component: () => import(/* webpackChunkName: "shipManagement" */ '@/components/shipManagement'),
        meta: {
          title: '船舶管理'
        }
      },
      {
        path: 'selfInspection',
        name: 'selfInspection',
        component: () => import(/* webpackChunkName: "selfInspection" */ '@/components/selfInspection'),
        meta: {
          title: '专项检查'
        }
      },
      {
        path: 'specialhistoryDetail',
        name: 'specialhistoryDetail',
        component: () => import(/* webpackChunkName: "specialhistoryDetail" */ '@/components/specialhistoryDetail'),
        meta: {
          title: '专项检查数据'
        }
      },
      // {
      //   path: 'audit',
      //   name: 'audit',
      //   component: audit,
      //   meta: {
      //     title: '审核'
      //   },
      //   // children: [
      //   //   {
      //   //     path: 'auditInfo',
      //   //     name: 'auditInfo',
      //   //     component: auditInfo,
      //   //     meta: {
      //   //       title: '审核详情'
      //   //     }
      //   //   }
      //   // ]
      // },
      {
        path: 'user',
        name: 'user',
        component: () => import(/* webpackChunkName: "user" */ '@/components/user'),
        meta: {
          title: '用户管理'
        },
        children: [
          {
            path: 'userTable',
            name: 'userTable',
            component: () => import(/* webpackChunkName: "userTable" */ '@/components/user/userTable'),
            meta: {
              title: '岸基用户'
            }
          },
          {
            path: 'crewUserTable',
            name: 'crewUserTable',
            component: () => import(/* webpackChunkName: "crewUserTable" */ '@/components/user/crewUserTable'),
            meta: {
              title: '船舶用户'
            }
          }
        ]
      },
      {
        path: 'viewDetails',
        name: 'viewDetails',
        component: () => import(/* webpackChunkName: "viewDetails" */ '@/components/viewDetails'),
        meta: {
          title: '检查记录详情页'
        }
      },
      {
        path: 'historyDetail',
        name: 'historyDetail',
        component: () => import(/* webpackChunkName: "historyDetail" */ '@/components/historyDetail'),
        meta: {
          title: '检查历史数据'
        }
      },
      {
        path: 'infoManagement',
        name: 'infoManagement',
        component: () => import(/* webpackChunkName: "infoManagement" */ '@/components/infoManagement'),
        meta: {
          title: '信息管理'
        }
      },
      {
        path: 'inspectionItemManagement',
        name: 'inspectionItemManagement',
        component: () => import(/* webpackChunkName: "inspectionItemManagement" */ '@/components/inspectionItemManagement'),
        meta: {
          title: '检查项管理'
        }
      },
      {
        path: 'fleetAssignment',
        name: 'fleetAssignment',
        component: () => import(/* webpackChunkName: "fleetAssignment" */ '@/components/fleetAssignment'),
        meta: {
          title: '船队指派'
        }
      },
      // {
      //   path: 'fleetHistoryDetail',
      //   name: 'fleetHistoryDetail',
      //   component: () => import(/* webpackChunkName: "fleetHistoryDetail" */ '@/components/fleetHistoryDetail'),
      //   meta: {
      //     title: '船队指派详情'
      //   }
      // },
      {
        path: 'rectificationManagement',
        name: 'rectificationManagement',
        component: () => import(/* webpackChunkName: "rectificationManagement" */ '@/components/rectificationManagement'),
        meta: {
          title: '整改管理'
        }
      },
      {
        path: 'help',
        name: 'help',
        component: () => import(/* webpackChunkName: "help" */ '@/components/help'),
        meta: {
          title: '使用说明'
        }
      },
      {
        path: 'rectificationManagementChildren',
        name: 'rectificationManagementChildren',
        component: () => import(/* webpackChunkName: "rectificationManagementChildren" */ '@/components/rectificationManagementChildren'),
        meta: {
          title: '整改管理详情'
        }
      },
      {
        path: 'risqInspection',
        name: 'risqInspection',
        component: () => import(/* webpackChunkName: "risqInspection" */ '@/components/risqInspection'),
        meta: {
          title: 'RISQ检查'
        }
      },
       {
        path: 'risqInspectionDetail',
        name: 'risqInspectionDetail',
        component: () => import(/* webpackChunkName: "risqInspectionDetail" */ '@/components/risqInspectionDetail'),
        meta: {
          title: 'RISQ检查数据'
        }
      }
    ]
  },

]
const router = new Router({
  routes
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router
